module.exports = __webpack_public_path__ + "static/media/lyn.13fc9947.png";